import * as Sentry from "@sentry/browser";
import { enableProdMode }         from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Logger }                 from '@cs/components/util';
import { LoggerUtil }             from '@cs/core/utils';

import { AppModule }     from './app/app.module';
import { pmAppSettings } from './environments/environment';
import { Environment }   from '@cs/common';

Sentry.init({
    dsn: "https://970e1dc9bc08466d93aaf9ccf64db290@errors.cohelion.com/34",
    tracesSampleRate: 1
})

if (pmAppSettings.environment === Environment.PRODUCTION) {
	enableProdMode();
	LoggerUtil.environment = pmAppSettings.environment;
	Logger.enabled         = false;
}

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));